import { isEqual } from 'lodash'
import moment, { Moment } from 'moment'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectAssetDetailPage } from 'store/asset/selectors'
import { selectTermsList } from 'store/settings/accountingPeriod/selectors'

export const useDisableImpairmentDates = () => {
  const { data: termYears } = useSelector(selectTermsList, isEqual)
  const { asset } = useSelector(selectAssetDetailPage, isEqual)

  return useCallback(
    (date: Moment) => {
      const startDate = asset.usage_started_at || asset.transition_at || asset.acquired_at
      if (termYears?.length > 0 && asset.impaired_at) {
        return !date.isBetween(
          moment(asset.impaired_at).add(1, 'month'),
          moment(termYears[termYears.length - 1].end_date)
        )
      }
      if (termYears?.length > 0 && !!startDate) {
        return !date.isBetween(moment(startDate), moment(termYears[termYears.length - 1].end_date))
      }
      return false
    },
    [asset, termYears]
  )
}
